import Breadcrumbs from '@/components/Breadcrumbs'
import Button from '@/components/Button'
import Portal from '@/components/Portal'
import usePage from '@/hooks/use-page'
import { useNavigate, useLocation, useParams } from '@/lib/router-dom'
import { getUseCaseId } from "@/utils/use-case-storage"
import { useEffect, useMemo, useState } from 'react'

const Page = ({role}) => {

	/*=================================================
		General
	/================================================*/

	const { useCaseId } = useParams()
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);

	const [pageTitle] = useState('Success')
	const [subPageTitle] = useState(useCase.name)

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ['Explore Use Cases', subPageTitle, pageTitle] })

	const { goTo } = useNavigate()
	const { currentState } = useLocation()
	const [successLabel, setSuccessLabel] = useState('enroll in use case')
	const [backButtonLabel, setBackButtonLabel] = useState('Back to Dashboard')

	/*=================================================
		API
	/================================================*/

	useEffect(()=>{
		//For success message label regarding disable agent principal and remove persona
		switch (currentState.messageType) {
			case "disableAgentPrincipal-persona":
				/** Scenario: Add and Remove personas and potentially disable agent */
				setSuccessLabel("change personas and disable Agent - Principal")
				break;
			case "disableAgentPrincipal":
				/** Scenario: Disable agent */
				setSuccessLabel("disable Agent - Principal function")
				break;
			case "enableAgentPrincipal-persona":
				/** Scenario: Add and Remove personas and potentially enable agent */
				setSuccessLabel("change personas and enable Agent - Principal")
				break;
			default:
				/** Scenario: Add and Remove personas */
				setSuccessLabel("change personas")
				break;
		}

		//For Back to button label
		if(role === 'admin'){
			setBackButtonLabel("Back to Organization's Dashboard")
		} else if(role !== 'admin') {
			setBackButtonLabel("Back to Use Cases")
		}
	},[])

	/*=================================================
		Navigate
	/================================================*/
	function backToEnrollment() {

		if (role !== 'admin'){
			goTo(`/use-cases`)
		}

		if(role === 'admin'){
			goTo(`/admin/participants/dashboard`,currentState)
		}
	}

	return (
		<>
			<div className="layout-feedback">
				<div className="layout-feedback__header layout-feedback__center">
					{role === 'admin' && currentState.from === "editPersona" && (
						<div className="layout-feedback__title" data-testid="admin-edit-persona">Your request to {successLabel} is being processed</div>
					)}

					{role === 'admin' && currentState.from !== "editPersona" && (
						<div className="layout-feedback__title" data-testid="admin-non-edit-persona">Successfully assigned a use case to the participating organization</div>
					)}
					{role !== 'admin' && (currentState.from === "addEnrol" || currentState.from === "enrollment") && (
						<>
							<div data-testid="participant-add-enroll" className='layout-feedback-enrol__content'>We are now processing your enrolment request.</div>
							<div className='layout-feedback-enrol__body'>You will be notified of any updates by your registered email address.</div>
						</>
					)}
					{role !== 'admin' && currentState.from === "editPersona" && (
						<>
						{
							currentState.messageType === 'enableAgentPrincipal' ?
								/** Scenario: Enable agent */
								(<div className="layout-feedback__title" data-testid="participant-add-enroll-persona">We are now processing your enabled request.</div>)
							:
								(<div className="layout-feedback__title" data-testid="participant-edit-persona">Your request to {successLabel} is being reviewed</div>)
						}
							<div className='layout-feedback-enrol__body'>You will be notified of any updates by your registered email address.</div>
						</>
					)}
				</div>
				<div className="layout-feedback__content">
					<img src="/img/success.png" />
				</div>
				<div className="layout-feedback__footer">
					<Button sizing='Medium' text= {backButtonLabel} round submit={() => backToEnrollment()} />
				</div>
			</div>
		</>
	)
}
export default Page
